import React, { useEffect, useState } from "react";
import * as Collapsible from "@radix-ui/react-collapsible";
import { FiMinus, FiPlus } from "react-icons/fi";
import { CgGym } from "react-icons/cg";
import { MdOutlineSchool, MdOutlineShoppingBag } from "react-icons/md";
import { RiStethoscopeLine } from "react-icons/ri";
import { isMobile } from "react-device-detect";
import slugify from "slugify";

function CollapsibleLocation({
  type,
  property,
  nearby,
  setNearby,
  titleThree,
  service,
  distance,
  mapReady,
}) {
  const [open, setOpen] = useState(type === "school");

  const [fetchDone, setFetchDone] = useState(false);

  async function getNearby(service, distance, type) {
    await service.nearbySearch(
      {
        location: {
          lat: property.propertyExactLocation.geoPoint._latitude,
          lng: property.propertyExactLocation.geoPoint._longitude,
        },
        rankBy: google.maps.places.RankBy.DISTANCE,
        type: type,
      },
      async (results, status, pagination) => {
        if (status !== "OK" || !results) {
          //   console.log(status);
          return;
        }

        let places = {};
        for (var i = 0; i < results.length; i++) {
          // check if business is operational

          let place = results[i];
          if (
            !place?.business_status ||
            place?.business_status === "OPERATIONAL"
          ) {
            // console.log(results[i]);
            // delete places[place.place_id].opening_hours;
            places[place.place_id] = place;
            place.opening_hours = null;
            if (
              type === "primary_school" &&
              place.types.includes("university")
            ) {
              // skip if university is included
              continue;
            }
            await distance.getDistanceMatrix(
              {
                origins: [
                  new google.maps.LatLng(
                    property.propertyExactLocation.geoPoint._latitude,
                    property.propertyExactLocation.geoPoint._longitude
                  ),
                ],

                destinations: [
                  new google.maps.LatLng(
                    results[i].geometry.location.lat(),
                    results[i].geometry.location.lng()
                  ),
                ],
                travelMode: "DRIVING",
                avoidHighways: true,
                avoidTolls: true,
              },
              function callback(response, status) {
                // See Parsing the Results for
                // the basics of a callback function.
                // console.log(response.rows[0].elements[0]);
                place.distance = response.rows[0].elements[0];
              }
            );
          }

          setNearby((prevNearby) => ({
            ...prevNearby,
            [type]: places,
          }));

          fetch(`/api/property/nearby`, {
            method: "POST",
            body: JSON.stringify({
              places,
              type,
              property,
            }),
          }).then(async (res) => {
            let r = await res.json();
            //   console.log(r);
            return r;
          });
        }
      }
    );
  }

  useEffect(() => {
    if (mapReady && !fetchDone && (!nearby || !nearby[getType(type)])) {
      console.log("called");
      getNearby(service.current, distance.current, getType(type)).then(() => {
        setFetchDone(true);
      });
    }
  }, [mapReady, fetchDone]);

  function getType(type) {
    if (type === "gym") {
      return "gym";
    } else if (type === "school") {
      return "primary_school";
    } else if (type === "shopping") {
      return "supermarket";
    } else if (type === "hospital") {
      return "hospital";
    }
  }

  function text(type) {
    if (type === "gym") {
      return "Gyms";
    } else if (type === "school") {
      return "Schools";
    } else if (type === "shopping") {
      return "Supermarkets and Malls";
    } else if (type === "hospital") {
      return "Hospitals";
    }
  }
  function icon(type) {
    if (type === "gym") {
      return <CgGym className="h-6 w-6 text-gray-900" />;
    } else if (type === "school") {
      return <MdOutlineSchool className="h-6 w-6 text-gray-900" />;
    } else if (type === "shopping") {
      return <MdOutlineShoppingBag className="h-6 w-6 text-gray-900" />;
    } else if (type === "hospital") {
      return <RiStethoscopeLine className="h-6 w-6 text-gray-900" />;
    }
  }

  return (
    <Collapsible.Root
      defaultOpen={type === "school" && isMobile}
      open={open}
      onOpenChange={(open) => setOpen(open)}
    >
      <div className=" flex select-none  flex-col divide-y divide-gray-300 rounded-md bg-gray-100 px-3 py-3 shadow lg:px-5 lg:py-5">
        <Collapsible.Trigger asChild>
          <a
            href={`#${slugify(text(type), { lower: true })}`}
            title={"Nearby " + text(type) + " around " + titleThree}
            onClick={(e) => {
              e.preventDefault();
              setOpen(!open);
            }}
            className=" flex flex-row items-center justify-between data-[state=closed]:pb-0 data-[state=open]:pb-5"
          >
            <div className=" flex flex-row items-center space-x-1 lg:space-x-3">
              <div className=" flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-white shadow-md lg:h-12 lg:w-12">
                {icon(type)}
              </div>
              <h3
                title={"Nearby " + text(type) + " around " + titleThree}
                className=" flex flex-col space-x-3 lg:flex-row lg:items-center"
              >
                <span className=" ml-3  font-semibold  lg:ml-0 lg:text-lg">
                  {text(type)}
                </span>
                {/* {type === "school" ? (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                    className="flex flex-row flex-wrap items-center  space-x-1 "
                  >
                    <span className=" cursor-pointer rounded-full  bg-blue-500 px-5 py-1 text-blue-100">
                      Primary school
                    </span>
                    <span className=" cursor-pointer rounded-full   border border-gray-400 px-5 py-1 text-gray-900">
                      Secondary school
                    </span>
                    <span className=" cursor-pointer rounded-full  border border-gray-400  px-5 py-1 text-gray-900">
                      Universities and Colleges
                    </span>
                  </div>
                ) : null} */}
              </h3>
            </div>
            <div
              //   href=""
              //   onClick={(e) => {
              //     e.preventDefault();
              //   }}
              className=" flex h-8 w-8 flex-shrink-0 cursor-pointer items-center justify-center rounded-lg bg-white shadow"
            >
              {open ? (
                <FiMinus className=" h-5 w-5 text-gray-900" />
              ) : (
                <FiPlus className=" h-5 w-5 text-gray-900" />
              )}
            </div>
          </a>
        </Collapsible.Trigger>
        {nearby && nearby[getType(type)] ? (
          <Collapsible.Content>
            <div className=" flex flex-col space-y-2 divide-y divide-gray-200">
              {Object.keys(nearby[getType(type)] ?? {}).length > 0
                ? Object.entries(nearby[getType(type)] ?? {})
                    .sort(
                      (a, b) =>
                        a[1].distance?.distance?.value -
                        b[1].distance?.distance?.value
                    )
                    .slice(0, 5)
                    .map((el) => {
                      //   console.log(el[1].distance);
                      return (
                        <div
                          key={el[0]}
                          className=" flex flex-row items-center  justify-between pb-1 pt-3  "
                        >
                          <span className=" mr-5 truncate capitalize lg:mr-20">
                            {el[1].name?.toLowerCase()}
                          </span>
                          <span
                            title={el[1].distance?.distance?.text + " away"}
                            className=" flex flex-shrink-0"
                          >
                            {el[1].distance?.distance?.text}
                          </span>
                        </div>
                      );
                    })
                : null}
            </div>
          </Collapsible.Content>
        ) : null}
      </div>
    </Collapsible.Root>
  );
}

export default CollapsibleLocation;
